import React from 'react';
import Styles from './lessons-plans-styles.scss';
import { Card, Container } from 'react-bootstrap';
import { IconNote2 } from '@/presentation/components/icons';
import { CustomBootstrapTable, InputSearchBase, TabHeader } from '@/presentation/components';
import { isMobile } from 'mobile-device-detect';
import useLessonPlans from './hooks/use-lesson-plans';
import UseManageModule from '@/presentation/hooks/use-manage-modules';
const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true
    },
    {
        dataField: 'download',
        text: 'Download',
        sort: true
    }
];
const LessonsPlans = ({ manageLessonsPlans, idLesson, manageUsers, getModulesFiltered }) => {
    const { modules } = UseManageModule(manageUsers, getModulesFiltered);
    const { dataLessonsPlans, loading, handleOnSearch } = useLessonPlans({
        manageLessonsPlans,
        idLesson,
        modules
    });
    return (React.createElement(Container, { className: Styles.mainWrap, fluid: true },
        React.createElement(TabHeader, { icon: React.createElement(IconNote2, null), title: "Lesson Plans" },
            React.createElement("div", { className: Styles.wrapBtns },
                React.createElement("div", { className: Styles.centerDivButtons, style: { flex: 1 } },
                    React.createElement(InputSearchBase, { placeholder: "Search...", onChange: e => handleOnSearch(e.target.value), customStyle: Styles.customStyleSearch })))),
        React.createElement(Card, { className: Styles.card },
            React.createElement(CustomBootstrapTable, { keyField: "id", data: dataLessonsPlans, columns: columns, loading: loading, showMobile: isMobile }))));
};
export default LessonsPlans;
